// System User Info
export var USER_DATA = 'USER_DATA';
export var USER_MENUS = 'USER_MENUS';
export var APPLICATION_CODES = 'APPLICATION_CODES';
export var USER_INFO = 'USER_INFO';
export var TASK_ITEM = 'TASK_ITEM';
